import Axios from 'axios';
import Apis from '../../config/Apis';
import {
  hideLoading,
  showAlert,
  showLoading,
  UpdateTypes,
} from '../Actions/GeneralActions';
import { headers } from "../../utills";
import { getPlaylist, getPlaylistSongs, getPublicPlaylist } from '../Actions/PlaylistAction';

export const PlaylistMiddleware = {

  getPlaylists: ({ name, id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          if (name)
            formdata.append('name', '')
          const data = await Axios.post(
            Apis.getVendorPlaylist,
            formdata,
            await headers.config(),
          );
          console.log('============getPlaylists', data);
          if (data?.status == 200) {
            dispatch(getPlaylist(data.data.data))
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'getPlaylists',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  getAdminPlaylist: ({ name }) => {
    return dispatch => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('name', '')
          const data = await Axios.post(
            Apis.getAdminPlaylist,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(getPublicPlaylist(data.data.data))
            resolve(true);
            dispatch(hideLoading());
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: 'getAdminPlaylist',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  createPlaylist: ({ name, description, image }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()

          formdata.append('name', name)
          formdata.append('description', description)
          formdata.append('image', image)
          const data = await Axios.post(
            Apis.createPlaylist,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            console.log(data.data.data)
            dispatch(getPlaylist(data.data.data))
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'getPlaylists',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  DeletePlaylist: ({ id }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)

          const data = await Axios.post(
            Apis.deletePlaylist,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            dispatch(getPlaylist(data.data.data))
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(hideLoading())
          dispatch(
            showAlert({
              title: 'DeletePlaylist',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  getYoutubeSongs: ({ name }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getYoutubeSongs(name),
            // await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data.data);
          }
        } catch (error) {
          console.log(error.response)
          reject(error);
          dispatch(
            showAlert({
              title: 'getYoutubeSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  getSongs: ({ id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          const data = await Axios.post(
            Apis.getPlaylistSongs,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(getPlaylistSongs(data.data.data))
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'getSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  addSongs: ({ play_list_id, name, image, description, type, video_id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', play_list_id)
          formdata.append('name', name)
          formdata.append('image', image)
          if (description)
            formdata.append('description', description)
          formdata.append('type', type)
          formdata.append('video_id', video_id)
          const data = await Axios.post(
            Apis.addPlaylistSong,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            console.log(data.data.data)
            dispatch(getPlaylistSongs(data.data.data))
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'addSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },


  deleteSongs: ({ id }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          const data = await Axios.post(
            Apis.deleteSong,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            dispatch(getPlaylistSongs(data.data.data))
            resolve(true);
          }
        } catch (error) {
          dispatch(hideLoading())
          reject(error);
          dispatch(
            showAlert({
              title: 'deleteSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },


  addSectionSongs: ({ section_id, play_list_id, name, image, description, type, video_id, event_id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('section_id', section_id)
          if (play_list_id)
            formdata.append('id', play_list_id)
          formdata.append('name', name)
          formdata.append('image', image)
          if (description)
            formdata.append('description', description)
          formdata.append('type', type)
          formdata.append('video_id', video_id)
          if (event_id)
            formdata.append('event_id', event_id)
          const data = await Axios.post(
            Apis.createTemplateSectionSong,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data.data.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'addSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },


  getSpotifyPlaylist: ({ }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getSpotifyPlaylist,
            await headers.configSpotify(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data);
          }
        } catch (error) {
          console.log(error.response.data)
          reject(error);
          dispatch(hideLoading())

        }
      });
    };
  },

  getSpotifyPlaylistSongs: ({ id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getSpotifyPlaylistSongs(id),
            await headers.configSpotify(),
          );
          if (data?.status == 200) {
            resolve(data.data);
          }
        } catch (error) {
          console.log(error.response.data)
          reject(error);

        }
      });
    };
  },


  deleteSectionSongs: ({ id }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          const data = await Axios.post(
            Apis.deleteTemplateSectionSong,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(hideLoading())
          reject(error);
          dispatch(
            showAlert({
              title: 'deleteSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  getSongIdeas: ({ id }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('template_id', id)
          const data = await Axios.post(
            Apis.songIdeas,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data.data);
          }
        } catch (error) {
          console.log(error.response.data)
          reject(error);
          dispatch(hideLoading())

        }
      });
    };
  },

  updateSectionSongLikeStatus: ({ id }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          const data = await Axios.post(
            Apis.updateSectionSongLikeStatus,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data.data);
          }
        } catch (error) {
          console.log(error.response.data)
          reject(error);
          dispatch(hideLoading())

        }
      });
    };
  },

  uploadBulkPlaylistSongs: ({ Queries, id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append(`id`, id)
          for (const [i, element] of Queries.entries()) {
            const trackName = element?.track?.name;
            const artistNames = element?.track.artists.map(a => a.name).join(' ');
            const youtubeSearchQuery = `${trackName} ${artistNames} ${element?.track?.external_ids?.isrc}`;
            formdata.append(`songs[${i}][query]`, youtubeSearchQuery)
          }
          const data = await Axios.post(
            Apis.uploadBulkPlaylistSongs,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(getPlaylistSongs(data.data.data))
            resolve(data.data.data);
          }
        } catch (error) {
          reject(error);

        }
      });
    };
  },

  getAllPlaylist: () => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getAllPlaylist,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(hideLoading())
          reject(error);
          dispatch(
            showAlert({
              title: 'getSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },


  addPlaylistIdInTemplateSection: ({ Queries, id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append(`id`, id)
          for (const [i, element] of Queries.entries()) {
            formdata.append(`playlist_ids[${i}]`, element?.id ? element?.id : element)
          }
          const data = await Axios.post(
            Apis.addPlaylistIdInTemplateSection,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data.data.data);
          }
        } catch (error) {
          reject(error);

        }
      });
    };
  },

  createTemplateSectionSongs: ({ Queries, id, event_id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append(`section_id`, id)
          formdata.append(`event_id`, event_id)
          for (const [i, element] of Queries.entries()) {
            const trackName = element?.track?.name;
            const artistNames = element?.track.artists.map(a => a.name).join(' ');
            const youtubeSearchQuery = `${trackName} ${artistNames} ${element?.track?.external_ids?.isrc}`;
            formdata.append(`songs[${i}][query]`, youtubeSearchQuery)
          }
          const data = await Axios.post(
            Apis.createTemplateSectionSongs,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            console.log(data.data.data)
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(showAlert({
            title: 'createTemplateSectionSongs',
            message: error?.response?.data?.message,
            type: 'Error',
            status: error?.response?.status,
          }))
          reject(error);

        }
      });
    };
  },

  getSectionPlayList: ({ id, }) => {
    return dispatch => {
      dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append(`section_id`, id)

          const data = await Axios.post(
            Apis.getSectionPlayList,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading())
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(hideLoading())
          dispatch(showAlert({
            title: 'getSectionPlayList',
            message: error?.response?.data?.message,
            type: 'Error',
            status: error?.response?.status,
          }))
          reject(error);

        }
      });
    };
  },


  getPlaylistSongs: ({ id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append('id', id)
          const data = await Axios.post(
            Apis.getPlaylistSongs,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data.data.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: 'getSongs',
              message: error?.response?.data?.message,
              type: 'Error',
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  bulkUploadSectionSongs: ({ section_id, songs, event_id }) => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData()
          formdata.append(`section_id`, section_id)
          formdata.append(`event_id`, event_id)
          for (const [i, element] of songs.entries()) {
            formdata.append(`songs[${i}][id]`, element?.id)
            formdata.append(`songs[${i}][image]`, element?.image)
            formdata.append(`songs[${i}][name]`, element?.name)
            formdata.append(`songs[${i}][video_id]`, element?.video_id)
            formdata.append(`songs[${i}][description]`, element?.description)
            // formdata.append(`songs[${i}][is_like]`, 1)
            formdata.append(`songs[${i}][type]`, 'youtube')
          }
          const data = await Axios.post(
            Apis.bulkUploadSectionSongs,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(showAlert({
            title: 'bulkUploadSectionSongs',
            message: error?.response?.data?.message,
            type: 'Error',
            status: error?.response?.status,
          }))
          reject(error);

        }
      });
    };
  },

};
